/**
 * ！！！此文件通过 Excel 文件生成，除调试开发外，不能手动修改。
 *
 * 生成方式：请查阅 README.md > 权限字段枚举 > 生成步骤
 *
 * 字段注释约定
 * 1.注释路径：父级menu_name-父级menu_name-........本级menu_name
 *
 * key名约定：
 * 1.将冒号、中划线、斜杠替换为下划线
 * 2.将多个连续下划线替换为单个下划线
 * 3.移除开头和结尾的下划线
 */
export enum CmRolePermKey {
  /** 首页团队及授权信息 */
  home_list = 'home:list',
  /** 首页团队及授权信息-团队信息修改 */
  team_update = 'team:update',
  /** 安全防护 */
  safemonitor_examination = 'safemonitor:examination',
  /** 安全防护-全面体检 */
  safemonitor_examination_stat = 'safemonitor:examination:stat',
  /** 安全防护-病毒木马查杀 */
  safemonitor_virus_scan = 'safemonitor:virus-scan',
  /** 安全防护-文件白名单 */
  strategy_get_by_type = 'strategy:get_by_type',
  /** 安全防护-漏洞修复 */
  leak_fix = 'leak:fix',
  /** 安全防护-基线扫描 */
  baselinecheck_result_list = 'baselinecheck:result:list',
  /** 安全防护-防护策略设置 */
  strategy_list_config = 'strategy:list:config',
  /** 安全防护-防护策略部署 */
  strategy_list_deploy = 'strategy:list:deploy',
  /** 威胁响应 */
  response = 'response',
  /** 威胁响应-响应处置 */
  response_handle = 'response:handle',
  /** 威胁响应-安全事件 */
  safeevent_list = 'safeevent:list',
  /** 审批中心 */
  approval_list = 'approval:list',
  /** 终端资产 */
  terminal_manager = 'terminal:manager',
  /** 终端资产-终端管理 */
  terminal_list = 'terminal:list',
  /** 终端资产-终端硬件信息 */
  terminal_hardware_list = 'terminal:hardware:list',
  /** 终端资产-终端状态 */
  safemonitor_terminal_status_stat = 'safemonitor:terminal-status:stat',
  /** 终端资产-终端部署 */
  team_deploy_conf_get = 'team:deploy_conf:get',
  /** 终端资产-终端发现 */
  client_find_discovered_list = 'client_find:discovered_list',
  /** 终端资产-分组管理 */
  terminal_group_manager = 'terminal:group:manager',
  /** 软件管理 */
  software_assets = 'software:assets',
  /** 软件管理-软件列表 */
  software_manager = 'software:manager',
  /** 软件管理-软件使用统计 */
  softmgr_userecord = 'softmgr:userecord',
  /** 软件管理-软件分发 */
  softmgr_soft_get = 'softmgr:soft:get',
  /** 软件管理-正版软件授权 */
  authenticsoft_list = 'authenticsoft:list',
  /** 软件管理-正版软件统计 */
  authenticsoft_softmgr_userecord_soft_list = 'authenticsoft:softmgr:userecord:soft-list',
  /** 软件管理-软件禁用 */
  softmgr_disable = 'softmgr:disable',
  /** 软件管理-文件分发 */
  file_batch_get = 'file:batch-get',
  /** 软件管理-启动项优化 */
  terminal_start_item = 'terminal:start-item',
  /** 软件管理-广告弹窗拦截 */
  popupintercept = 'popupintercept',
  /** 数据安全 */
  data_security = 'data:security',
  /** 数据安全-屏幕水印 */
  watermark_strategy_list = 'watermark:strategy:list',
  /** 数据安全-USB设备管控 */
  peripheralcontrol_manager = 'peripheralcontrol:manager',
  /** 数据安全-勒索防护 */
  ransomwareprotect = 'ransomwareprotect',
  /** 数据安全-数据外发管控 */
  sensitivewords = 'sensitivewords',
  /** 上网防护 */
  portcontrol = 'portcontrol',
  /** 上网防护-端口管控 */
  portcontrol_port = 'portcontrol:port',
  /** 上网防护-域名访问限制 */
  portcontrol_port_terminal = 'portcontrol:port:terminal',
  /** 上网防护-IP访问限制 */
  ip_limit_list = 'ip:limit:list',
  /** 上网防护-终端流量管控 */
  flow_control_list = 'flow:control:list',
  /** 上网防护-远程登录认证 */
  remote_login_authentication = 'remote:login:authentication',
  /** 日志审计 */
  logmanage = 'logmanage',
  /** 日志审计-预警信息日志 */
  logmanage_alert_history_list = 'logmanage:alert-history:list',
  /** 日志审计-病毒查杀日志 */
  logmanage_virus_stat = 'logmanage:virus:stat',
  /** 日志审计-硬件变更日志 */
  logmanage_hardware_change_list = 'logmanage/hardware-change:list',
  /** 日志审计-软件变更日志 */
  logmanage_software_change_list = 'logmanage:software-change:list',
  /** 日志审计-终端加入/离开日志 */
  logmanage_join_record_list = 'logmanage:join-record:list',
  /** 日志审计-禁用软件日志 */
  softmgr_teamsoft_disable_log = 'softmgr:teamsoft:disable_log',
  /** 日志审计-程序进程日志 */
  processdisable_list = 'processdisable:list',
  /** 日志审计-软件正版化日志 */
  softmgr_teamsoft_auth_disable_log = 'softmgr:teamsoft:auth:disable_log',
  /** 日志审计-域名策略日志 */
  terminal_net_limit_stat = 'terminal:net-limit:stat',
  /** 日志审计-外发管控日志 */
  sensitivefilesend_send_file_record = 'sensitivefilesend:send_file_record',
  /** 日志审计-终端排障日志 */
  terminal_order_get_logs_task_list = 'terminal-order:get_logs_task_list',
  /** 日志审计-IP访问限制日志 */
  terminal_net_ip_limit_list = 'terminal:net-ip-limit:list',
  /** 日志审计-远程登录日志 */
  terminal_remote_login_log = 'terminal:remote_login_log',
  /** 日志审计-审计日志 */
  logmanage_audit = 'logmanage:audit',
  /** 日志审计-指令下发日志 */
  terminal_order_command_stat = 'terminal-order:command-stat',
  /** 日志审计-管理员操作日志 */
  logmanage_admin_operation_list = 'logmanage:admin-operation:list',
  /** 设置 */
  setting = 'setting',
  /** 设置-资产登记 */
  asset_registration = 'asset:registration',
  /** 设置-管理员列表 */
  team_admin_list = 'team:admin:list',
  /** 设置-邀请管理员 */
  team_admin_invite = 'team:admin:invite',
  /** 设置-系统配置 */
  teamconfig_get = 'teamconfig:get',
  /** 设置-邮件通知 */
  notice_mail_strategy_get = 'notice:mail-strategy:get',
  /** 设置-权限（角色）配置 */
  role_get = 'role:get',
  /** 设置-权限（角色）配置-新增角色 */
  role_add = 'role:add',
  /** 设置-权限（角色）配置-编辑角色 */
  role_update = 'role:update',
  /** 添加新管理员 */
  user_add = 'user:add',
  /** 编辑管理员信息 */
  user_update_detail = 'user:update:detail',
  /** 发放恢复码 */
  user_mfa_recovery_codes_issue = 'user:mfa:recovery-codes:issue',
  // 账号邮件
  user_send_email = 'user:send:email',
  /** 重置密码 */
  user_update_resetPwd = 'user:update:resetPwd',
  /** 删除管理员 */
  user_update_delete = 'user:update:delete',
  /** 禁用管理员 */
  user_update_invalid = 'user:update:invalid',
  /** 我的服务 */
  my_service = 'my:service',
  /** 我的服务-订阅市场 */
  permission_order_get_prices = 'permission_order:get_prices',
  /** 我的服务-我的订阅 */
  permission_order_service_list = 'permission_order:service_list',
  /** 我的服务-我的订单 */
  permission_order_order_history = 'permission_order:order_history',
  /** 首页团队及授权信息-授权信息弹窗（私有化） */
  authorization_upload = 'authorization:upload',
  /** 终端流量状态（私有化） */
  flow_control_status = 'flow:control:status',
  /** 级联中心（私有化） */
  cascade = 'cascade',
  /** 级联中心-分支总览（私有化） */
  cascade_team_terminal_info = 'cascade:team_terminal_info',
  /** 级联中心-级联管理（私有化） */
  cascade_superior_applies = 'cascade:superior_applies',
  /** 级联中心-审批管理（私有化） */
  cascade_applies = 'cascade:applies',
  /** 远程登录日志（私有化） */
  terminal_Remote_login_log = 'terminal:Remote_login_log',
  /** 设置-管理员账号（私有化） */
  team_admin = 'team:admin',
  /** 设置-系统版本更新（私有化） */
  upgrade_version = 'upgrade:version',
  /** 设置-病毒库更新（私有化） */
  sample_update_update_state = 'sample:update:update_state',
  /** 设置-服务状态（私有化） */
  metric_server_status = 'metric:server_status',
  /** 设置-LDAP-同步设置（私有化） */
  terminal_group_ldap_config = 'terminal-group:ldap_config',
}
